// TODO: Convert all use of this function to use urlSearchParam instead
export default (param) => {
  const urlSearchParams = new URLSearchParams(window.location.search);

  if (param) return urlSearchParams.get(param);
  return urlSearchParams;
};
